import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

/**
 * Dividers are used to visually separate content in a list or group.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/divider#usage)
 * - [Props](https://blockparty.endpoint.com/components/divider#props)
 * <br />
 *
 */
const Divider = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    orientation = 'horizontal',
    weight = 1,
    ...rest
  } = _ref;
  const borderProps = orientation === 'vertical' ? {
    width: `${weight}px`
  } : {
    height: `${weight}px`
  };
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    "aria-orientation": orientation,
    as: "hr",
    bg: "divider",
    border: "0",
    m: "space0"
  }, borderProps, rest), children);
});

export { Divider };
